import NotificationManagerContainer from './NotificationManagerContainer';
export default NotificationManagerContainer;